import { BotHistoryItem, PromotionSkill, Skill } from 'maia'
import { apiCall } from '../utils/api'

type BotMessage = {
   messageId?: string
   threadId: string
   answer: string
   data: {
      skills?: Array<Skill>
      promotions?: Array<PromotionSkill>
      [key: string]: any
   }
}

export type RequestType = {
   locale: string
   account?: string
   hotelId?: number
   destinationId?: number
   message?: string
   skill?: string
   threadId?: string
}

export async function chat(request: RequestType, access_token?: string): Promise<BotMessage | null> {
   const { locale, account, threadId, ...rest } = request
   try {
      const result = await apiCall(
         {
            url: `${process.env.REACT_APP_PUBLIC_SERVICES_API}/chat${threadId ? `/${threadId}` : ''}`,
            method: 'POST',
            data: {
               account,
               ...rest,
            }
         },
         account,
         locale,
         access_token,
      )
      return result.data
   } catch (error) {
      return null
   }
}

export type ChatHistoryRequest = {
   locale: string
   account?: string
   threadId: string
}

export async function getChatHistory(request: ChatHistoryRequest, access_token?: string): Promise<{ messages: Array<BotHistoryItem>, threadId: string }> {
   const { locale, account, threadId } = request
   const result = await apiCall(
      {
         url: `${process.env.REACT_APP_PUBLIC_SERVICES_API}/chat/${threadId}`,
         method: 'GET',
      },
      account,
      locale,
      access_token,
   )
   return result.data
}

type RateChatRequest = {
   threadId: string
   isPositive: boolean
   account?: string
   locale?: string
   messageId?: string
}

export async function rateChat({ threadId, isPositive, account, locale, messageId }: RateChatRequest): Promise<boolean | null> {
   try {
      await apiCall(
         {
            url: `${process.env.REACT_APP_PUBLIC_SERVICES_API}/chat/${threadId}/rate`,
            method: 'POST',
            data: { positive: isPositive, ...(messageId && { messageId }) },
         },
         account,
         locale,
      )
      return true
   } catch {
      return null
   }
}
